var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"calc(100vh)"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}}),_c('v-col',{attrs:{"cols":"12"}},[_c('v-main',{staticClass:"bg-main",staticStyle:{"min-height":"calc(100vh - 80px)"},attrs:{"fill-height":""}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }